import log from './client'

module.exports = log
